module.exports = __webpack_public_path__ + "static/img/2-3.109659f2.png";